export default {
  resorder_issues: "Order Issues",
  resno_delivered_orders: "No delivered orders",
  resreport_view: "Report / View",
  ressupplier: "Supplier",

  status_delivered: "DELIVERED",
  status_placed: "PLACED",
  status_pending: "PENDING",
  status_cancelled: "CANCELLED",
  status_under_review: "UNDER REVIEW",
  status_issue_resolved: "ISSUE RESOLVED",
  status_acknowledged: "ACKNOWLEDGED",
  status_rejected: "REJECTED"
};